var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddApplicant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:add-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 2C6.65412 2 8 3.34588 8 5C8 6.65412 6.65412 8 5 8C3.34588 8 2 6.65412 2 5C2 3.34588 3.34588 2 5 2ZM5 1.25C2.92888 1.25 1.25 2.92888 1.25 5C1.25 7.07113 2.92888 8.75 5 8.75C7.07113 8.75 8.75 7.07113 8.75 5C8.75 2.92888 7.07113 1.25 5 1.25ZM6.875 4.625H5.375V3.125H4.625V4.625H3.125V5.375H4.625V6.875H5.375V5.375H6.875V4.625Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddApplicant);
export default __webpack_public_path__ + "static/media/addApplicant.dcd4244740c4bd9e64752fb5fc747b33.svg";
export { ForwardRef as ReactComponent };